import { createSelector } from '@reduxjs/toolkit';

import type { SliceStateFromReducer } from 'shared/types';

import type { metadataSlice } from './metadata.slice';

type TMetadataState = SliceStateFromReducer<typeof metadataSlice>;

export const metadataSelector = (state: TMetadataState) => state.metadata;

export const seoContentBlocksSelector = createSelector(metadataSelector, (metadata) => metadata?.contentBlocks || []);
export const seoH1Selector = createSelector(metadataSelector, (metadata) => metadata?.heading);
export const seoSubHeadingSelector = createSelector(metadataSelector, (metadata) => metadata?.subHeading);

export const hasAnySeoDataSelector = createSelector(metadataSelector, (metadata) => {
  if (!metadata) {
    return false;
  }

  const hasSeoBreadcrumbs = !!metadata?.breadcrumbs?.length;
  const hasPrefooter = !!metadata?.prefooter?.length;
  const hasSeoBlocks = !!metadata?.text;

  return hasSeoBreadcrumbs || hasPrefooter || hasSeoBlocks;
});
